import React from "react";

export const FilterIcon = ({
  width,
  color,
}: {
  width?: number;
  color?: string;
}) => {
  const heightToWidthRatio = 10 / 14;
  const w = width || 14;

  return (
    <svg
      width={w}
      height={w * heightToWidthRatio}
      viewBox="0 0 14 10"
      fill="none"
      id="FilterIcon"
    >
      <path
        d="M1 1H13"
        stroke={color || "#454545"}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M3.5 5H10.5"
        stroke={color || "#454545"}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6 9H8"
        stroke={color || "#454545"}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
};
